import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import CreateForm from 'screens/shared/storages/create';
import moment from 'moment';
import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import Shared from 'screens/shared';

export default ({ history, match }) => {
  // eslint-disable-next-line object-curly-newline
  const { dcId, serverId, id, type } = match.params; // type = 'cdrom' || 'volume'
  const [showSnapshotModal, setShowSnapshotModal] = useState(false);

  const { [ACTIONS_TYPES.STORAGE.GET]: storage = {} } = useSelector((e) => e);
  const { properties = {}, metadata = {} } = storage;

  useEffect(() => {
    if (!serverId) actions.storage.get({ dcId, id });
    else if (type === 'volume') actions.server.getVolume({ id: serverId, dcId, volumeId: id });
    else if (type === 'cdrom') actions.server.getCdRom({ id: serverId, dcId, cdromId: id });
  }, [dcId, id, serverId, type]);

  const renderBoolean = (value) => (value
    ? <Shared.widgets.Icon name="check" className="success-txt" style={{ fontSize: 18 }} />
    : <Shared.widgets.Icon name="times" className="danger-txt" style={{ fontSize: 18 }} />
  );

  const storagePropertiesRow = [
    [_t('Availability Zone'), properties?.availabilityZone],
    [_t('Size'), `${properties?.size}GB`],
    [_t('Type'), properties?.type],
    [_t('Bus'), properties?.bus],
    [_t('Device Number'), properties?.deviceNumber],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const CdRompropertiesRow = [
    [_t('Size'), `${properties?.size}GB`],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const CapabilitiesRows = [
    ['', 'Hot Plug', 'Hot Unplug'],
    ['CPU', renderBoolean(properties?.cpuHotPlug), renderBoolean(properties?.cpuHotUnplug)],
    ['Disc Virtio', renderBoolean(properties?.discVirtioHotPlug), renderBoolean(properties?.discVirtioHotUnplug)],
    ['NIC', renderBoolean(properties?.nicHotPlug), renderBoolean(properties?.nicHotUnplug)],
    ['RAM', renderBoolean(properties?.ramHotPlug), renderBoolean(properties?.ramHotUnplug)],
  ];

  const deleteHandler = () => {
    if (!serverId) actions.storage.delete({ dcId, id });
    else if (type === 'volume') actions.server.deattachVolume({ id: serverId, dcId, volumeId: id });
    else if (type === 'cdrom') actions.server.deattachCdRom({ cdRomId: id, dcId, id: serverId });
    history.goBack();
  };

  const createSnapshotHandler = (isSnapshot) => {
    if (isSnapshot) actions.storage.createSnapshot();
    setShowSnapshotModal(false);
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.STORAGE}
      title={type === 'cdrom' ? 'CD-Rom' : 'Storage'}
      strapTitle={properties?.name}
      strapIcon={type === 'cdrom' ? 'compact-disc' : 'hdd'}
      onDelete={deleteHandler}
      isEditButton={type !== 'cdrom'}
      editForm={<CreateForm storage={{ id, name: properties?.name, size: properties?.size }} isEdit />}
      editAction={ACTIONS_TYPES.STORAGE.UPDATE}
    >
      {type !== 'cdrom' && <Shared.widgets.Tiles items={[{ name: 'Snapshot', icon: 'camera', onClick: () => setShowSnapshotModal(true) }]} />}
      <Shared.widgets.Properties properties={type === 'cdrom' ? CdRompropertiesRow : storagePropertiesRow} />
      <Shared.widgets.Properties properties={CapabilitiesRows} title={_t('Capabilities')} />
      <Shared.dialog.Confirm show={showSnapshotModal} message="Do you want to take a snapshot of this storage?" onClose={createSnapshotHandler} />
    </Shared.widgets.Page>
  );
};
